export const ActionTypes = {
  SET_USER_DETAILS: 'SET_USER_DETAILS',
  SELECTED_PRODUCT: 'SELECTED_PRODUCT',
  REMOVE_SELECTED_PRODUCT: 'REMOVE_SELECTED_PRODUCT',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
};
